import BigNumber from 'bignumber.js';
import { Timeframe } from '@ankr.com/chains-list';

import { ESeconds } from 'modules/common/constants/const';

const timeframeToSecondsMap: Record<Timeframe, number> = {
  [Timeframe.Hour]: ESeconds.Hour,
  [Timeframe.Day]: ESeconds.Day,
  [Timeframe.Week]: ESeconds.Week,
  [Timeframe.Month]: ESeconds.Month,
};

export const getRequestsAverage = (
  requests: BigNumber = new BigNumber(0),
  timeframe: Timeframe,
) => {
  if (requests.isEqualTo(0)) {
    return '0';
  }

  const requestsPerSecond = requests.div(timeframeToSecondsMap[timeframe]);

  let decimalPlaces = 1;

  if (requestsPerSecond.isLessThan(1)) {
    decimalPlaces = 5;
  }

  return requestsPerSecond.toFormat(decimalPlaces);
};
